// extracted by mini-css-extract-plugin
export default {"articleTitle":"noticeModule_articleTitle__IzIGD","row":"noticeModule_row__u2bN4"};